import { ComponentConfig, WithId, WithPuckProps } from "@measured/puck";
import classNames from "classnames";
import styles from "./space.module.scss";
import { spacingOptions } from "../../config/options";

export interface SpaceProps {
  direction?: "" | "vertical" | "horizontal";
  options?: {
    desktop?: { size?: string };
    tablet?: { size?: string };
    mobile?: { size?: string };
  };
}

export const Space = (props: WithId<WithPuckProps<SpaceProps>>) => {
  const { id, direction, options } = props;
  const uniqueClass = `space-responsive-${id}`;

  return (
    <div>
      <style>{`
        @media only screen and (max-width: 743px) {
          .${uniqueClass} {
            width: ${options?.mobile?.size ?? "0px"};
            height: ${options?.mobile?.size ?? "0px"};
          }
        }

        @media only screen and (min-width: 744px) and (max-width: 1023px) {
          .${uniqueClass} {
            width: ${options?.tablet?.size ?? "0px"};
            height: ${options?.tablet?.size ?? "0px"};
          }
        }

        @media only screen and (min-width: 1024px) {
          .${uniqueClass} {
            width: ${options?.desktop?.size ?? "0px"};
            height: ${options?.desktop?.size ?? "0px"};
          }
        }
      `}</style>

      <div
        ref={props.puck.dragRef}
        className={classNames(styles.container, uniqueClass, {
          [styles.vertical]: direction === "vertical",
          [styles.horizontal]: direction === "horizontal",
        })}
      />
    </div>
  );
};

export const PuckSpace: ComponentConfig<SpaceProps> = {
  label: "Space",
  fields: {
    direction: {
      type: "radio",
      label: "Direction",
      options: [
        { value: "", label: "Both" },
        { value: "vertical", label: "Vertical" },
        { value: "horizontal", label: "Horizontal" },
      ],
    },
    options: {
      type: "object",
      label: "Responsive Sizes",
      objectFields: {
        desktop: {
          type: "object",
          label: "Desktop",
          objectFields: {
            size: {
              type: "select",
              label: "Size",
              options: spacingOptions,
            },
          },
        },
        tablet: {
          type: "object",
          label: "Tablet",
          objectFields: {
            size: {
              type: "select",
              label: "Size",
              options: spacingOptions,
            },
          },
        },
        mobile: {
          type: "object",
          label: "Mobile",
          objectFields: {
            size: {
              type: "select",
              label: "Size",
              options: spacingOptions,
            },
          },
        },
      },
    },
  },
  defaultProps: {
    direction: "",
    options: {
      desktop: { size: "24px" },
      tablet: { size: "16px" },
      mobile: { size: "12px" },
    },
  },
  inline: true,
  render: (props) => <Space {...props} />,
};
